interface Props {
  /** Last-known display name, if any. */
  name?: string;
  /** Re-attempt connection (uses the host-provided token / tokenProvider). */
  onRejoin: () => void;
}

/**
 * Shown after the user leaves in authenticated (JWT) mode. The widget can't
 * log a user in by itself — that's the host app's job — so we don't keep a
 * dead, disconnected chat on screen. Instead we tell them to log in again to
 * rejoin. The Rejoin button re-attempts the connection for hosts that still
 * have a valid session/token.
 */
export function LeftScreen({ name, onRejoin }: Props) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center p-8 text-center">
      <div className="w-14 h-14 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center mb-4">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="10 17 15 12 10 7" />
          <line x1="15" y1="12" x2="3" y2="12" />
        </svg>
      </div>
      <h3 className="text-lg font-semibold text-gray-900">You’ve left the chat</h3>
      <p className="mt-2 max-w-xs text-sm text-gray-500">
        {name ? <>You were signed in as <span className="font-medium text-gray-700">{name}</span>. </> : null}
        Please log in again to rejoin the chat.
      </p>
      <button
        type="button"
        onClick={onRejoin}
        className="mt-5 inline-flex items-center justify-center rounded-xl bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300"
      >
        Rejoin
      </button>
    </div>
  );
}
